/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  trans,
  useSoyuzExperiment,
  useSoyuzLocales
} from '@spotahome/soyuz/client';

import { TrustpilotWidget } from '@spotahome/ui-library';
import { TEMPLATE_IDS } from '@spotahome/ui-library/src/tenant/components/TrustpilotWidget/TrustpilotWidget';

import withInViewEvent from '@spotahome/ui-library/src/tenant/components/withInViewEvent';
import { LANDING_SECTIONS } from '@spotahome/ui-library/src/tenant/components/utils/seoConstants';
import useHorizontalDrag from '@spotahome/ui-library/src/hooks/useHorizontalDrag';

import Testimonial from './Testimonial';

import './TestimonialsCarousel.scss';

const RATINGS = [
  {
    id: 'testimonial-1',
    stars: 4,
    comment: 'landingpage.testimonials.comment.1',
    author: 'Luise Aymar',
    country: 'Germany'
  },
  {
    id: 'testimonial-2',
    stars: 5,
    comment: 'landingpage.testimonials.comment.2',
    author: 'Diego Ruiz',
    country: 'Bolivia'
  },
  {
    id: 'testimonial-3',
    stars: 4,
    comment: 'landingpage.testimonials.comment.3',
    author: 'Leila Helal',
    country: 'Uruguay'
  }
];

const TestimonialsCarousel = () => {
  const {
    containerRef,
    handleMouseDown,
    handleMouseUp,
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd
  } = useHorizontalDrag({
    onMoveStart: () => {},
    onMove: () => {}
  });
  const { current } = useSoyuzLocales();

  const isTrustpilotMicroButtonWidgetExperiment =
    useSoyuzExperiment('TrustpilotMicroReviewCountWidget').get('behaviour') ===
    'variant';

  const trustPilotTemplate = isTrustpilotMicroButtonWidgetExperiment
    ? TEMPLATE_IDS.MICRO_REVIEW_COUNT
    : TEMPLATE_IDS.MICRO_STAR;

  return (
    <section className="testimonials-carousel">
      <div className="testimonials-carousel__header">
        <h3 className="testimonials-carousel__title">
          {trans('landingpage.label.testimonials.carousel.title')}
        </h3>
      </div>

      <ul
        className="testimonials-carousel__carousel-list"
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
        onTouchMove={handleTouchMove}
        ref={containerRef}
      >
        {RATINGS.map(testimonial => (
          <li
            key={testimonial.id}
            className="testimonials-carousel__testimonial"
          >
            <Testimonial
              id={testimonial.id}
              stars={testimonial.stars}
              comment={trans(testimonial.comment)}
              author={testimonial.author}
              country={testimonial.country}
            />
          </li>
        ))}
      </ul>

      <TrustpilotWidget
        locale={current}
        className="testimonials-carousel__trustpilot"
        template={trustPilotTemplate}
      />
    </section>
  );
};

export default withInViewEvent(LANDING_SECTIONS.cardTestimonialQuote)(
  TestimonialsCarousel
);
